import type { PropsWithChildren } from 'react'
import * as React from 'react'
import HighlightLabel from './HighlightLabel'

type InheritedLabelProps = Pick<React.ComponentProps<typeof HighlightLabel>, 'format' | 'variant'>

interface Props extends InheritedLabelProps {
  className?: string
  icon?: React.ReactNode
}

const PromotionLabel = React.forwardRef<HTMLSpanElement, PropsWithChildren<Props>>((props, ref) => {
  const { icon, children, ...rest } = props

  return <HighlightLabel
    {...rest}
    ref={ref}
    startIcon={icon}
  >
    {children}
  </HighlightLabel>
})

PromotionLabel.displayName = 'PromotionLabel'

export default PromotionLabel
